module.exports = "<div id=\"samba-player\"></div>"